import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "template"]

  add_col(event) {
    event.preventDefault()
    const tableInfo = this.tableInfo()
    const template = this.templateTarget.innerHTML
    for (var i = 0, row; row = this.tableTarget.rows[i]; i++) {
      row.insertCell(-1).innerHTML = template.replace(/ROW_INDEX/g, i).replace(/COL_INDEX/g, tableInfo.cols_count)
    }
  }

  add_row(event) {
    event.preventDefault()
    const tableInfo = this.tableInfo()
    const template = this.templateTarget.innerHTML

    let row = this.tableTarget.insertRow(-1)
    Array.from(Array(tableInfo.cols_count).keys()).forEach( function (index) {
      row.insertCell(index).innerHTML = template.replace(/ROW_INDEX/g, tableInfo.rows_count).replace(/COL_INDEX/g, index)
    })
  }

  tableInfo() {
    return {
      cols_count: this.tableTarget.rows[0].cells.length,
      rows_count: this.tableTarget.rows.length
    }
  }

}
